/* Feelgood Legs: behaviour for the FL sections.
   Every feature looks up its own section, so sections can be moved, removed, added again or
   re-rendered in the Shopify theme editor without breaking the rest of the page. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
  const smoothstep = (p, e0, e1) => { const t = clamp((p - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const DESIGN = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- entrances ---------- */
  const io = new IntersectionObserver(es => {
    es.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      io.unobserve(e.target);
      setTimeout(() => e.target.classList.add('settled'), 1400);
    });
  }, { rootMargin: '0px 0px -12% 0px' });
  function initReveals(root) {
    $$('.reveal, .dots', root).forEach(el => {
      // in the editor everything shows at once, so a freshly edited section is never invisible
      if (DESIGN || RM.matches) el.classList.add('in', 'settled');
      else io.observe(el);
    });
  }

  /* ---------- the scroll-scrubbed video hero ---------- */
  function rng(seed) { let s = seed >>> 0; return () => (s = (s * 1664525 + 1013904223) >>> 0) / 4294967296; }
  function splitWords(el, seed, spread) {
    if (!el) return;
    const r = rng(seed);
    const words = el.textContent.trim().split(/\s+/).filter(Boolean);
    el.textContent = '';
    words.forEach((w, i) => {
      const s = document.createElement('span');
      s.className = 'w';
      s.textContent = w + (i < words.length - 1 ? ' ' : '');
      s.style.setProperty('--th', (i / Math.max(1, words.length) * spread + r() * 0.05).toFixed(3));
      el.appendChild(s);
    });
  }

  // mode 'wide' plays the 16:9 film, mode 'tall' the portrait film made for phones
  function createHero(heroEl, mode) {
    const stage = $('.stage', heroEl);
    const video = $('video', stage);
    const posterLayer = $('.poster', stage);
    const cue = $('.cue', stage);
    const ring = $('.cue .ring', stage);
    const tall = mode === 'tall';
    const VIDEO_URL = tall ? stage.dataset.videoTall : stage.dataset.video;
    const POSTER_URL = tall ? stage.dataset.posterTall : stage.dataset.poster;
    const VIDEO_BYTES = Number(tall ? stage.dataset.bytesTall : stage.dataset.bytes) || 6000000;   // fallback when Content-Length is missing
    const listeners = new AbortController();
    // start clean, even if this markup was rendered before (theme editor re-renders, rotation)
    stage.classList.remove('video-ready', 'video-failed', 'scrolled');
    stage.classList.toggle('tall', tall);
    cue.classList.remove('done');
    ring.style.setProperty('--ld', 126);
    video.removeAttribute('src');
    video.style.display = '';
    posterLayer.style.backgroundImage = '';

    $$('.b2 .half', stage).forEach((h, i) => splitWords(h, 11 + i, 0.4));
    splitWords($('.b3 .line', stage), 23, 0.45);
    splitWords($('.b4 .top .line', stage), 37, 0.42);

    const bands = $$('.band', stage).map(el => ({
      el, a: parseFloat(el.dataset.a), b: parseFloat(el.dataset.b), ramp: parseFloat(el.dataset.ramp) || 0, op: -1, k: -1, off: null
    }));
    const LAST = bands.length - 1;

    let alive = true, loadK = 0;
    let heroTop = 0, heroRange = 1;
    let seekBusy = false, pendingTime = null;
    let target = 0, shown = 0, rafId = null, lastTick = 0, onScreen = true, videoReady = false, scrolledFlag = null;
    let scrubOn = false, inited = false, fetchCtrl = null, blobUrl = null;

    function updateCaptions(p) {
      for (let i = 0; i < bands.length; i++) {
        const bd = bands[i];
        const f = Math.min(0.02, (bd.b - bd.a) / 3);
        const inn = i === 0 ? 1 : smoothstep(p, bd.a, bd.a + f);
        const out = i === LAST ? 1 : 1 - smoothstep(p, bd.b - f, bd.b);
        const op = inn * out;
        let k = clamp((p - bd.a) / (bd.ramp || Math.min(0.025, (bd.b - bd.a) * 0.35)), 0, 1);
        if (i === 0) k = Math.max(k, loadK);
        if (Math.abs(op - bd.op) > 0.004 || (op === 0 && bd.op !== 0) || (op === 1 && bd.op !== 1)) { bd.op = op; bd.el.style.opacity = op.toFixed(3); }
        if (Math.abs(k - bd.k) > 0.008 || (k === 1 && bd.k !== 1) || (k === 0 && bd.k !== 0)) { bd.k = k; bd.el.style.setProperty('--k', k.toFixed(3)); }
        const off = op < 0.01;
        if (off !== bd.off) { bd.off = off; bd.el.classList.toggle('off', off); }
      }
    }
    function measure() {
      heroTop = heroEl.getBoundingClientRect().top + scrollY;
      heroRange = Math.max(1, heroEl.offsetHeight - innerHeight);
      // a theme header above the hero pushes the stage down; the scroll cue lifts by the same amount
      stage.style.setProperty('--hero-offset', Math.round(heroTop) + 'px');
    }
    const progress = () => clamp((scrollY - heroTop) / heroRange, 0, 1);

    function requestSeek(t) {
      if (!video.duration || !videoReady) return;
      if (seekBusy) { pendingTime = t; return; }
      seekBusy = true;
      video.currentTime = t;
    }
    video.addEventListener('seeked', () => {
      seekBusy = false;
      if (pendingTime !== null) { const t = pendingTime; pendingTime = null; requestSeek(t); }
    }, { signal: listeners.signal });
    video.addEventListener('error', () => { seekBusy = false; pendingTime = null; if (alive && video.getAttribute('src')) failVideo(); }, { signal: listeners.signal });

    function tick(now) {
      const dt = Math.min(100, now - (lastTick || now));
      lastTick = now;
      shown += (target - shown) * (1 - Math.pow(1 - 0.16, dt / 16.667));
      if (Math.abs(target - shown) < 0.0005) { shown = target; rafId = null; lastTick = 0; }
      else rafId = requestAnimationFrame(tick);
      if (videoReady) requestSeek(shown * Math.max(0, video.duration - 0.04));
      updateCaptions(shown);
    }
    function onScroll() {
      target = progress();
      const sc = scrollY > heroTop + 40;
      if (sc !== scrolledFlag) { scrolledFlag = sc; stage.classList.toggle('scrolled', sc); }
      if (rafId === null && onScreen) rafId = requestAnimationFrame(tick);
    }
    const heroIO = new IntersectionObserver(es => { onScreen = es[0].isIntersecting; if (onScreen && scrubOn) onScroll(); });
    heroIO.observe(heroEl);

    function failVideo() {
      cue.classList.add('done');
      stage.classList.add('video-failed');
      video.removeAttribute('src');
      video.style.display = 'none';
    }
    async function loadHeroBlob() {
      fetchCtrl = new AbortController();
      let watchdog = setTimeout(() => fetchCtrl.abort(), 20000);
      const res = await fetch(VIDEO_URL, { priority: 'low', signal: fetchCtrl.signal });
      if (!res.ok || !res.body) throw new Error('video ' + res.status);
      const total = Number(res.headers.get('Content-Length')) || VIDEO_BYTES;
      const reader = res.body.getReader();
      const chunks = [];
      let got = 0, lastRing = 0;
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        clearTimeout(watchdog);
        watchdog = setTimeout(() => fetchCtrl.abort(), 20000);
        chunks.push(value);
        got += value.length;
        const frac = Math.min(1, got / total);
        const now = performance.now();
        if (now - lastRing > 100 || frac === 1) { lastRing = now; ring.style.setProperty('--ld', Math.round(126 * (1 - frac))); }
      }
      clearTimeout(watchdog);
      if (!alive) return;
      ring.style.setProperty('--ld', 0);
      blobUrl = URL.createObjectURL(new Blob(chunks, { type: 'video/mp4' }));
      video.src = blobUrl;
      video.load();
      video.addEventListener('canplay', () => {
        if (!alive) return;
        // iPhones only paint seeked frames after the video has played once; muted inline play is allowed
        const pl = video.play();
        if (pl && pl.then) pl.then(() => video.pause()).catch(() => {});
        videoReady = true;
        requestSeek(progress() * Math.max(0, video.duration - 0.04));
        stage.classList.add('video-ready');
        cue.classList.add('done');
      }, { once: true, signal: listeners.signal });
    }
    function initOnce() {
      if (inited) return;
      inited = true;
      posterLayer.style.backgroundImage = "url('" + POSTER_URL + "')";
      let started = false;
      const start = () => { if (started || !alive) return; started = true; loadHeroBlob().catch(() => { if (alive) failVideo(); }); };
      const img = new Image();
      img.onload = start; img.onerror = start;
      img.src = POSTER_URL;
      setTimeout(start, 4000);
      // band one assembles once on load, then hands over to scroll
      const t0 = performance.now();
      const ramp = now => {
        if (!alive) return;
        const t = clamp((now - t0 - 250) / 1400, 0, 1);
        loadK = 1 - Math.pow(1 - t, 3);
        updateCaptions(shown);
        if (t < 1) requestAnimationFrame(ramp);
      };
      requestAnimationFrame(ramp);
    }
    function enable() {
      if (scrubOn) return; scrubOn = true;
      measure();
      initOnce();
      addEventListener('scroll', onScroll, { passive: true });
      bands.forEach(b => { b.op = -1; b.k = -1; b.off = null; });
      shown = target = progress();
      updateCaptions(shown);
      onScroll();
    }
    function disable() {
      if (!scrubOn) return; scrubOn = false;
      removeEventListener('scroll', onScroll);
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; lastTick = 0; }
    }
    function destroy() {
      alive = false;
      disable();
      heroIO.disconnect();
      listeners.abort();
      if (fetchCtrl) fetchCtrl.abort();
      video.removeAttribute('src');
      video.load();
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    }
    return {
      el: heroEl, mode, enable, disable, destroy,
      resize() { if (scrubOn) { measure(); onScroll(); } },
      get on() { return scrubOn; }, get top() { return heroTop; }, get range() { return heroRange; }
    };
  }

  /* which hero a visitor gets. The two static gates are the same strings as the CSS media query;
     portrait screens get the portrait film, everything else the wide one. */
  const STATIC_GATES = [
    '(prefers-reduced-motion: reduce)',
    '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)'
  ];
  const TALL = '(orientation: portrait)';
  const SAVE_DATA = !!(navigator.connection && navigator.connection.saveData);
  let hero = null, heroEl = null;
  function heroMode() {
    if (STATIC_GATES.some(q => matchMedia(q).matches)) return 'static';
    if (!matchMedia(TALL).matches) return 'wide';
    // no portrait film (switched off in the editor) or the visitor asked to save data: the photo
    return SAVE_DATA || !$('.stage', heroEl).dataset.videoTall ? 'static' : 'tall';
  }
  function applyHeroMode() {
    if (!heroEl) return;
    const m = heroMode();
    document.documentElement.classList.toggle('hero-photo', m === 'static');   // CSS shows the photo hero
    if (m === 'static') { if (hero) hero.disable(); return; }
    if (!hero || hero.mode !== m) { if (hero) hero.destroy(); hero = createHero(heroEl, m); }
    hero.enable();
  }
  const MQLS = [...STATIC_GATES, TALL].map(q => matchMedia(q));
  MQLS.forEach(m => m.addEventListener('change', applyHeroMode));

  /* ---------- the menu goes solid after the hero ---------- */
  function navState() {
    const nav = $('.nav');
    if (!nav) return;
    const s = hero && hero.on ? scrollY > hero.top + hero.range + innerHeight * 0.6 : scrollY > innerHeight * 0.6;
    if (s !== nav.classList.contains('solid')) nav.classList.toggle('solid', s);
  }
  addEventListener('scroll', navState, { passive: true });

  /* ---------- "Zo werkt het": the self-drawing sock and the press-and-hold ---------- */
  const hows = new Map();
  function createHow(root) {
    const holdbox = $('.holdbox', root);
    if (!holdbox) return null;
    const sock = $('svg.sock', root);
    const btn = $('.holdbtn', holdbox);
    const label = $('.holdlabel', holdbox);
    const bar = $('.bar', holdbox);
    const idleText = label.textContent;
    const doneText = btn.dataset.done || idleText;
    let hp = 0, holding = false, hraf = null, hlast = 0, hdone = false, hpShown = -1, stepShown = -1;
    let drawOn = false, drawLast = -1, drawRaf = null, alive = true;

    const measureBar = () => holdbox.style.setProperty('--barw', bar.clientWidth + 'px');
    measureBar();
    function applyHp() {
      if (Math.abs(hp - hpShown) > 0.004 || hp === 0 || hp === 1) { hpShown = hp; holdbox.style.setProperty('--hp', hp.toFixed(3)); }
      const st = hp >= 0.98 ? 3 : hp >= 0.6 ? 2 : hp >= 0.2 ? 1 : 0;   // the three steps light up as the hold progresses
      if (st !== stepShown) { stepShown = st; holdbox.dataset.step = st; }
    }
    function hstep(now) {
      if (!alive) return;
      const dt = Math.min(64, now - (hlast || now));
      hlast = now;
      if (holding) hp = Math.min(1, hp + dt / 1700);
      else if (!hdone) hp = Math.max(0, hp * Math.pow(0.5, dt / 600) - dt * 0.00015);
      applyHp();
      if (hp >= 1 && !hdone) { hdone = true; holdbox.classList.add('done'); label.textContent = doneText; }
      if ((holding && hp < 1) || (!holding && !hdone && hp > 0)) hraf = requestAnimationFrame(hstep);
      else { hraf = null; hlast = 0; }
    }
    function finish() { hp = 1; hdone = true; applyHp(); holdbox.classList.add('done'); label.textContent = doneText; }
    function startHold() {
      if (RM.matches) { finish(); return; }
      if (hdone) { hdone = false; hp = 0; applyHp(); holdbox.classList.remove('done'); label.textContent = idleText; }
      holding = true;
      if (hraf === null) hraf = requestAnimationFrame(hstep);
    }
    function endHold() {
      holding = false;
      if (hraf === null && !hdone && hp > 0) hraf = requestAnimationFrame(hstep);
    }
        // één klik (of Enter/spatie) speelt de hele animatie af, vasthouden is niet nodig
    const play = () => { if (alive) startHold(); };
    btn.addEventListener('click', play);
    // speel één keer vanzelf af als de sectie voor de helft in beeld is
    let autoPlayed = false;
    const autoIO = new IntersectionObserver(es => {
      if (autoPlayed || !es[0].isIntersecting) return;
      autoPlayed = true;
      autoIO.disconnect();
      setTimeout(play, 500);
    }, { threshold: 0.5 });
    autoIO.observe(holdbox);

    function drawStep() {
      drawRaf = null;
      if (RM.matches || !alive) return;
      const r = root.getBoundingClientRect();
      const p = clamp((innerHeight - r.top) / (innerHeight * 0.9), 0, 1);
      if (Math.abs(p - drawLast) > 0.004 || (p === 1 && drawLast !== 1)) {
        drawLast = p;
        sock.style.setProperty('--draw', (1 - p).toFixed(3));
        sock.style.setProperty('--drawn', p.toFixed(3));
      }
    }
    const onDrawScroll = () => { if (drawOn && drawRaf === null) drawRaf = requestAnimationFrame(drawStep); };
    const drawIO = new IntersectionObserver(es => { drawOn = es[0].isIntersecting; onDrawScroll(); });
    drawIO.observe(root);
    addEventListener('scroll', onDrawScroll, { passive: true });

    return {
      measureBar,
      pin() {
        sock.style.setProperty('--draw', 0);
        sock.style.setProperty('--drawn', 1);
        holding = false;
        if (hraf !== null) { cancelAnimationFrame(hraf); hraf = null; }
        finish();
      },
      unpin() {
        drawLast = -1; onDrawScroll();
        hdone = false; hp = 0; applyHp();
        holdbox.classList.remove('done');
        label.textContent = idleText;
      },
      destroy() {
        alive = false;
        drawIO.disconnect();
                autoIO.disconnect();
        removeEventListener('scroll', onDrawScroll);
        if (hraf !== null) cancelAnimationFrame(hraf);
        if (drawRaf !== null) cancelAnimationFrame(drawRaf);
      }
    };
  }

  /* ---------- reduced motion, live in both directions ---------- */
  function pinAll() {
    document.documentElement.classList.add('rm-pinned');
    $$('.reveal, .dots').forEach(el => el.classList.add('in', 'settled'));
    hows.forEach(h => h.pin());
  }
  function unpinAll() {
    if (!document.documentElement.classList.contains('rm-pinned')) return;
    document.documentElement.classList.remove('rm-pinned');
    hows.forEach(h => h.unpin());
  }
  RM.addEventListener('change', e => {
    if (e.matches) pinAll();
    else { unpinAll(); applyHeroMode(); }
  });

  /* ---------- wiring, also for sections the theme editor re-renders ---------- */
  function sectionOf(el) { return el.closest('.shopify-section') || el.parentElement; }
  function initSection(root) {
    initReveals(root);
    const found = root.matches && root.matches('.hero') ? root : $('.hero', root);
    if (found) { if (hero) hero.destroy(); hero = null; heroEl = found; applyHeroMode(); }
    $$('.holdbox', root).forEach(box => {
      const sec = sectionOf(box);
      if (hows.has(sec)) hows.get(sec).destroy();
      const h = createHow(sec);
      if (h) { hows.set(sec, h); if (RM.matches) h.pin(); }
    });
    navState();
  }
  function teardownSection(root) {
    if (heroEl && root.contains(heroEl)) { if (hero) hero.destroy(); hero = null; heroEl = null; }
    hows.forEach((h, sec) => { if (root === sec || root.contains(sec)) { h.destroy(); hows.delete(sec); } });
  }
  document.addEventListener('shopify:section:load', e => initSection(e.target));
  document.addEventListener('shopify:section:unload', e => teardownSection(e.target));

  addEventListener('resize', () => { if (hero) hero.resize(); hows.forEach(h => h.measureBar()); navState(); });
  document.addEventListener('visibilitychange', () => document.body.classList.toggle('paused', document.hidden));

  initSection(document);
  if (RM.matches) pinAll();
})();
